const Pulse = ({
  isActive,
  size = "size-3",
  isPending,
}: {
  isActive: Boolean
  size?: string
  isPending?: boolean
}) => {
  return (
    <>
      <span className={`relative flex ${size}`}>
        <span
          className={`animate-ping absolute inline-flex h-full w-full rounded-full ${
            isPending
              ? "bg-yellow-400"
              : isActive
                ? "bg-green-400"
                : "bg-red-400"
          } opacity-75`}
        ></span>
        <span
          className={`relative inline-flex rounded-full ${size} ${
            isPending
              ? "bg-yellow-500"
              : isActive
                ? "bg-green-500"
                : "bg-red-500"
          }`}
        ></span>
      </span>
    </>
  )
}

export default Pulse
